const AuthSubHeaduing = ({ text }: { text: string }) => {
    return (<h3 className="text-white text-sm  font-medium">{text}</h3>);
}

export default AuthSubHeaduing;